import { render, staticRenderFns } from "./ForcePasswordReset.vue?vue&type=template&id=4ef6f31c&scoped=true&"
import script from "./ForcePasswordReset.vue?vue&type=script&lang=js&"
export * from "./ForcePasswordReset.vue?vue&type=script&lang=js&"
import style0 from "./ForcePasswordReset.vue?vue&type=style&index=0&id=4ef6f31c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef6f31c",
  null
  
)

export default component.exports